import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { AllowAccess } from '@features/auth/ControlAccess/AllowAccess/AllowAccess.tsx';
import {
  DownloadedFileExtensions,
  DownloadedFileTypes,
} from '@features/campaigns/shared/types/exportFileDownloadType.ts';
import stylesPageHeader from '@shared/components/PageHeader/PageHeader.module.scss';
import PageHeader from '@shared/components/PageHeader/PageHeader.tsx';
import { i18nNameSpace } from '@shared/consts/i18n';
import { Permissions } from '@shared/consts/permissions.ts';
import commonListStyles from '@shared/containers/ListPage/ListPage.module.scss';
import { useExportFileDownload } from '@shared/hooks/useExportFileDownload.ts';

function UsersListPage() {
  const { t } = useTranslation(i18nNameSpace.USERS);

  const { setDownloadFileExtension } = useExportFileDownload({
    fileType: DownloadedFileTypes.LIST,
  });

  const handleDownloadUsersList = () => {
    setDownloadFileExtension(DownloadedFileExtensions.XLSX);
  };

  return (
    <div className={commonListStyles.wrapper}>
      <PageHeader>
        <div className={commonListStyles.headerContentContainer}>
          <div className={commonListStyles.pageTitleContainer}>
            <h2 className={stylesPageHeader.pageTitle}>{t('page.title')}</h2>
          </div>
        </div>
      </PageHeader>

      <section className={commonListStyles.contentWrapper}>
        <AllowAccess requiredPermissions={[Permissions.SMB_USER_LIST_ALLOWED_COUNTRIES]}>
          <Button onClick={handleDownloadUsersList}>{t('page.list.downloadUsers')}</Button>
        </AllowAccess>
      </section>
    </div>
  );
}

export default UsersListPage;
